// SPDX-License-Identifier: LicenseRef-Proprietary
// Copyright (c) 2026 Invariant Holdings LLC

import { panelTokens } from "@csk/demo-ui";

export function severityColor(severity: string): string {
  if (severity === "critical") return panelTokens.accentRed;
  if (severity === "high") return panelTokens.accentAmber;
  return panelTokens.accentBlue;
}
